// extracted by mini-css-extract-plugin
module.exports = {"star":"_262626","disabled":"_8defde","progressContainer":"_20b0c1","root":"_ddf248","number":"_fa1f76","reviewNumbers":"_8cd091"};